<div class="searcher-container">
  <div class="search-bar" (click)="focusInputProvider()">
    <img
      src="../../../assets/icons/search-icon.svg"
      alt="Search Icon"
      class="search-icon"
    />
    <input
      #searchInputProvider
      (input)="filterProvider(searchInputProvider.value)"
      type="text"
      [placeholder]="'NO_PROVIDER_SERVICE.SIDE_BAR.11' | translate"
      class="search-bar-input"
    />
  </div>
</div>
<div class="description-container">
  <p class="no-provider-alert-text">
    {{ "NO_PROVIDER_SERVICE.PROVIDER_LIST.0" | translate }}
    <span class="no-provider-alert-text-bolt"
      >{{ FilteredProviders.length }}
      {{ "NO_PROVIDER_SERVICE.PROVIDER_LIST.1" | translate }}
    </span>
  </p>
  <img
    class="loading-spinner"
    *ngIf="LoadingData"
    src="../../../../../assets/loading-spinner.gif"
    alt=""
  />
</div>
<div class="cards-container" *ngIf="!LoadingData">
  <div
    class="providers-cards-scroll-container"
    [style.minHeight]="MinHeight"
    [style.maxHeight]="MaxHeight"
  >
    <div
      class="provider-card"
      *ngFor="let provider of FilteredProviders"
      (click)="selectProvider(provider)"
    >
      <div
        class="option-checkbox"
        [ngClass]="{
          'option-checkbox-selected': provider == ProviderSelected
        }"
      >
        <div *ngIf="provider == ProviderSelected" class="black-point"></div>
      </div>

      <div class="card-info">
        <p class="provider-title">{{ provider.name }}</p>
        <div class="location-container">
          <img
            class="infoRow-header-icon"
            src="../../../assets/icons/location-marker-grey.webp"
            alt=""
          />
          <p class="provider-address">{{ provider.address }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
